<template>
  <el-tabs v-model="tabsName" @tab-click="gotoOtherPage">
    <el-tab-pane v-for="(item,index) in list" :key="index" :label="item.name" :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../common/js/tool.js";
  export default {
    data() {
      return {
        tabsName: "",
        list: [
          {name: '出入人口统计', url: '/search/person-in-out'},
          {name: '进出区域信息查询', url: '/search/area-in-out'},
          {name: '发退卡信息查询', url: '/search/card-in-out'},
          {name: '当前位置列表', url: '/search/tracking'},
          {name: '人员信息查询', url: '/search/person-info'},
          {name: '人员绑定查询', url: '/search/person-bind'},
          {name: '未解绑人员查询', url: '/search/person-binded'},
        ]
      };
    },

    props: ["name"],

    computed: {},

    created() {
    },

    updated() {
      this.tabsName = this.name;
    },

    methods: {
      gotoOtherPage() {
        // let hash = window.location.hash.replace("#", "");
        let hash = this.$route.query.u;
        // console.log(hash);
        // console.log(this.$route.query.u);
        for (let i = 0; i < this.list.length; i++) {
          if (this.tabsName == this.list[i].name) {
            console.log(this.list[i].url);
            this.$router.push({
              path: this.list[i].url,
              query: {u: "/search/person-in-out"}
            });
            break;
          }
        }
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../common/less/variable.less";
</style>
